// Generated types for ProposalBatch
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ProposalStatus } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProposalBatchReadAPI extends RFLPElementReadAPI {
  /** UUID of the entity whose change triggered this batch. */
  originating_entity_id: string;
  /** Short type name of the triggering entity. */
  originating_entity_type: string;
  /** Text snapshot of the triggering change (e.g. 'payload increased from 3 kg to 5 kg'). */
  originating_change_summary?: string;
  /** Aggregate lifecycle state. APPLIED once all members are APPLIED / REJECTED / SUPERSEDED. */
  status?: ProposalStatus;
}

export interface ProposalBatchWriteAPI extends RFLPElementWriteAPI {
  /** UUID of the entity whose change triggered this batch. */
  originating_entity_id: string;
  /** Short type name of the triggering entity. */
  originating_entity_type: string;
  /** Text snapshot of the triggering change (e.g. 'payload increased from 3 kg to 5 kg'). */
  originating_change_summary?: string;
  /** Aggregate lifecycle state. APPLIED once all members are APPLIED / REJECTED / SUPERSEDED. */
  status?: ProposalStatus;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProposalBatchReadAPISchema: z.ZodType<ProposalBatchReadAPI> = RFLPElementReadAPISchemaObject.extend({
  originating_entity_id: z.string(),
  originating_entity_type: z.string(),
  originating_change_summary: z.string().optional(),
  status: z.nativeEnum(ProposalStatus).optional(),
}).passthrough();

export const ProposalBatchWriteAPISchema: z.ZodType<ProposalBatchWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  originating_entity_id: z.string(),
  originating_entity_type: z.string(),
  originating_change_summary: z.string().optional(),
  status: z.nativeEnum(ProposalStatus).optional(),
}).passthrough();
